export default function setBlobApplicationType(
  blob,
  applicationType = 'application/pdf'
) {
  if (blob instanceof Blob) {
    return blob.slice(0, blob.size, applicationType);
  }
  console.warn('Не blob:', blob, applicationType);
  return blob;
}
